export interface FeatureOptionProps {
  name: string
  value: string | number | null
}

export interface FeaturePillProps {
  name: string
  value: string
  selected?: boolean
  size?: string
}

export const MIN_PRICES: FeatureOptionProps[] = [
  { name: "No Min", value: null },
  { name: "$50k", value: 50000 },
  { name: "$100k", value: 100000 },
  { name: "$150k", value: 150000 },
  { name: "$200k", value: 200000 },
  { name: "$250k", value: 250000 },
  { name: "$300k", value: 300000 },
  { name: "$350k", value: 350000 },
  { name: "$400k", value: 400000 },
  { name: "$450k", value: 450000 },
  { name: "$500k", value: 500000 },
  { name: "$600k", value: 600000 },
  { name: "$700k", value: 700000 },
  { name: "$800k", value: 800000 },
  { name: "$900k", value: 900000 },
  { name: "$1M", value: 1000000 },
  { name: "$1.5M", value: 1500000 },
  { name: "$2M", value: 2000000 },
  { name: "$2.5M", value: 2500000 },
  { name: "$3M", value: 3000000 },
  { name: "$3.5M", value: 3500000 },
  { name: "$4M", value: 4000000 },
  { name: "$4.5M", value: 4500000 },
  { name: "$5M", value: 5000000 },
]

export const MAX_PRICES: FeatureOptionProps[] = [
  { name: "$50k", value: 50000 },
  { name: "$100k", value: 100000 },
  { name: "$150k", value: 150000 },
  { name: "$200k", value: 200000 },
  { name: "$250k", value: 250000 },
  { name: "$300k", value: 300000 },
  { name: "$350k", value: 350000 },
  { name: "$400k", value: 400000 },
  { name: "$450k", value: 450000 },
  { name: "$500k", value: 500000 },
  { name: "$600k", value: 600000 },
  { name: "$700k", value: 700000 },
  { name: "$800k", value: 800000 },
  { name: "$900k", value: 900000 },
  { name: "$1M", value: 1000000 },
  { name: "$1.5M", value: 1500000 },
  { name: "$2M", value: 2000000 },
  { name: "$2.5M", value: 2500000 },
  { name: "$3M", value: 3000000 },
  { name: "$3.5M", value: 3500000 },
  { name: "$4M", value: 4000000 },
  { name: "$4.5M", value: 4500000 },
  { name: "$5M", value: 5000000 },
  { name: "No Max", value: null },
]

export const MIN_PROFITS: FeatureOptionProps[] = [
  { name: "No Min", value: null },
  { name: "$10k", value: 10000 },
  { name: "$20k", value: 20000 },
  { name: "$30k", value: 30000 },
  { name: "$40k", value: 40000 },
  { name: "$50k", value: 50000 },
  { name: "$60k", value: 60000 },
  { name: "$70k", value: 70000 },
  { name: "$80k", value: 80000 },
  { name: "$90k", value: 90000 },
  { name: "$100k", value: 100000 },
  { name: "$125k", value: 125000 },
  { name: "$150k", value: 150000 },
  { name: "$175k", value: 175000 },
  { name: "$200k", value: 200000 },
  { name: "$225k", value: 225000 },
  { name: "$250k", value: 250000 },
  { name: "$275k", value: 275000 },
  { name: "$300k", value: 300000 },
  { name: "$325k", value: 325000 },
  { name: "$350k", value: 350000 },
  { name: "$375k", value: 375000 },
  { name: "$400k", value: 400000 },
  { name: "$425k", value: 425000 },
  { name: "$450k", value: 450000 },
  { name: "$475k", value: 475000 },
  { name: "$500k", value: 500000 },
  { name: "$550k", value: 550000 },
  { name: "$600k", value: 600000 },
  { name: "$650k", value: 650000 },
  { name: "$700k", value: 700000 },
  { name: "$750k", value: 750000 },
  { name: "$800k", value: 800000 },
  { name: "$850k", value: 850000 },
  { name: "$900k", value: 900000 },
  { name: "$950k", value: 950000 },
  { name: "$1M", value: 1000000 },
]

export const MIN_YEARS: FeatureOptionProps[] = [
  { name: "No Min", value: null },
  { name: "1900", value: 1900 },
  { name: "1910", value: 1910 },
  { name: "1920", value: 1920 },
  { name: "1930", value: 1930 },
  { name: "1940", value: 1940 },
  { name: "1950", value: 1950 },
  { name: "1960", value: 1960 },
  { name: "1970", value: 1970 },
  { name: "1980", value: 1980 },
  { name: "1990", value: 1990 },
  { name: "2000", value: 2000 },
  { name: "2005", value: 2005 },
  { name: "2010", value: 2010 },
  { name: "2015", value: 2015 },
  { name: "2020", value: 2020 },
  { name: "2021", value: 2021 },
  { name: "2022", value: 2022 },
  { name: "2023", value: 2023 },
  { name: "2024", value: 20024 },
]

export const MAX_YEARS: FeatureOptionProps[] = [
  { name: "1900", value: 1900 },
  { name: "1910", value: 1910 },
  { name: "1920", value: 1920 },
  { name: "1930", value: 1930 },
  { name: "1940", value: 1940 },
  { name: "1950", value: 1950 },
  { name: "1960", value: 1960 },
  { name: "1970", value: 1970 },
  { name: "1980", value: 1980 },
  { name: "1990", value: 1990 },
  { name: "2000", value: 2000 },
  { name: "2005", value: 2005 },
  { name: "2010", value: 2010 },
  { name: "2015", value: 2015 },
  { name: "2020", value: 2020 },
  { name: "2021", value: 2021 },
  { name: "2022", value: 2022 },
  { name: "2023", value: 2023 },
  { name: "2024", value: 20024 },
  { name: "No Max", value: null },
]

export const BEDS: FeaturePillProps[] = [
  { name: "Any", value: "Any" },
  { name: "1", value: "1" },
  { name: "2", value: "2" },
  { name: "3", value: "3" },
  { name: "4+", value: "4+" },
]

export const BATHS: FeaturePillProps[] = [
  { name: "Any", value: "Any" },
  { name: "1", value: "1" },
  { name: "1.5", value: "1.5" },
  { name: "2", value: "2" },
  { name: "2.5", value: "2.5" },
  { name: "3", value: "3" },
  { name: "3.5", value: "3.5" },
  { name: "4+", value: "4+" },
]

export const MIN_SQFTS: FeatureOptionProps[] = [
  { name: "No Min", value: null },
  { name: "500", value: 500 },
  { name: "750", value: 750 },
  { name: "1,000", value: 1000 },
  { name: "1,250", value: 1250 },
  { name: "1,500", value: 1500 },
  { name: "1,750", value: 1750 },
  { name: "2,000", value: 2000 },
  { name: "2,250", value: 2250 },
  { name: "2,500", value: 2500 },
  { name: "2,750", value: 2750 },
  { name: "3,000", value: 3000 },
  { name: "3,250", value: 3250 },
  { name: "3,500", value: 3500 },
  { name: "3,750", value: 3750 },
  { name: "4,000", value: 4000 },
  { name: "5,000", value: 5000 },
  { name: "6,000", value: 6000 },
]

export const MAX_SQFTS: FeatureOptionProps[] = [
  { name: "500", value: 500 },
  { name: "750", value: 750 },
  { name: "1,000", value: 1000 },
  { name: "1,250", value: 1250 },
  { name: "1,500", value: 1500 },
  { name: "1,750", value: 1750 },
  { name: "2,000", value: 2000 },
  { name: "2,250", value: 2250 },
  { name: "2,500", value: 2500 },
  { name: "2,750", value: 2750 },
  { name: "3,000", value: 3000 },
  { name: "3,250", value: 3250 },
  { name: "3,500", value: 3500 },
  { name: "3,750", value: 3750 },
  { name: "4,000", value: 4000 },
  { name: "5,000", value: 5000 },
  { name: "6,000", value: 6000 },
  { name: "No Max", value: null },
]
